import { Service } from 'typedi';
import { BaseService, IBaseService, SearchRequest, ServerResponse } from '../../../core/services/BaseService';
// import { BeneficiaryModel, DirectDepositModel, FederalTaxWithHoldingModel, OptionSelectionModel, OraUrlModel, PersonalInformationModel, RetirementDateModel, ServiceRetirementSignOffModel, StateTaxWithHoldingModel, StepStatuses, TemporaryAnnuityModel } from './retiree/memberCreate/ApplyModels';
import { Appl } from '../../../core/Appl';
import { SubmissionModel } from './retiree/addEdit/SubmissionModel';
import { OraModel } from './oraTest/OraModel';

export interface ISraService extends IBaseService {

  getUrl(model: OraModel): Promise<ServerResponse>;
  getRetirementAppForAdminAsync(submissionId: number): Promise<ServerResponse>;
  updateRetirementAppForAdminAsync(model: SubmissionModel): Promise<ServerResponse>;
  getSubmittedDocumentsAsync(submissionId: number): Promise<ServerResponse>;
  getQueueAsFileAsync(format: string | undefined, searchModel: SearchRequest | undefined, status: string | undefined): Promise<ServerResponse>;
}

@Service() // eslint-disable-next-line
export class SraService extends BaseService implements ISraService {
  constructor() {
    super(`${Appl.Setting.Services.RetirementServiceUrl}`);
  }

  public async getUrl(model: OraModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/retiree/afr/url`, model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async getRetirementAppForAdminAsync(submissionId: number): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/retirement/retiree/afrForAdmin/${submissionId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }
  public async updateRetirementAppForAdminAsync(model: SubmissionModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/retiree/UpdateRetirementInfoByAdmin`, model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async getSubmittedDocumentsAsync(submissionId: number): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/retirement/Retiree/SubmittedDocuments/${submissionId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async getQueueAsFileAsync(format: string | undefined, searchModel: SearchRequest | undefined,status:string|undefined): Promise<ServerResponse> {
        try {
            const response = await this.client.post(`/retirement/Submission/1/${status}/download-submission-queue/${format}`, searchModel, { responseType: 'blob' });
            return this.getResponse(response);
        } catch (error: unknown) {
            return await this.getErrorResponse(error);
        }
    }

}
